import { useEffect } from 'react';
import { useAuth } from 'react-oidc-context';

function Callback() {
  const auth = useAuth();

  useEffect(() => {
    // Trata explicitamente o retorno do Cognito nessa rota.
    // Isso evita ficar preso no /callback e ajuda a manter a URL limpa.
    let cancelled = false;

    const run = async () => {
      try {
        if (auth.isLoading) return;

        // Processa o callback (code/state) e salva o usuário.
        // Se já estiver autenticado, não faz nada.
        if (!auth.isAuthenticated) {
          await auth.signinRedirectCallback();
        }

        if (cancelled) return;

        // Limpa a URL e volta pro root sem manter /callback no histórico
        window.history.replaceState({}, document.title, '/');
        window.location.replace('/');
      } catch (e) {
        if (cancelled) return;
        console.error('Erro no callback:', e);
        window.history.replaceState({}, document.title, '/');
        window.location.replace('/');
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [auth]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column'
    }}>
      <div>Processando autenticação...</div>
      {auth.error && (
        <div style={{ color: 'red', marginTop: '10px' }}>
          Erro: {auth.error.message}
        </div>
      )}
    </div>
  );
}

export default Callback;